import React from 'react';
import UnitsPage from './UnitsPage';

const CajaSecaPage = () => {
  return <UnitsPage tipoUnidad="Caja seca" title="Caja Seca" />;
};

export default CajaSecaPage;
